var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('b-button',{staticClass:"m-3",attrs:{"size":"lg"},on:{"click":function($event){return _vm.$emit('clicked-login')}}},[_vm._v("Login")]),_c('b-button',{staticClass:"m-3",attrs:{"size":"lg"},on:{"click":function($event){return _vm.$emit('clicked-register')}}},[_vm._v("Register")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }